import { getToken } from "../authorization/auth";
import { API_ENDPOINT } from "../authorization/const";

export async function getTicket(ticket) {
    const res = await fetch(API_ENDPOINT + "tickets/get/" + ticket);
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function newTicket(priority, subject, message, phone, email) {
    const _json = { "token": getToken(), "priority": priority, "subject": subject, "message": message, "phone": phone, "email": email };
    const res = await fetch(API_ENDPOINT + "tickets/new", {
        method: "POST",
        body: JSON.stringify(_json)
    });
    if (res.status === 201)
        return await res.json();
    throw await res.json();
}

export async function newComment(ticket, comment, username, status) {
    const _json = { "comment": comment, "person": username, "status": status };
    const res = await fetch(API_ENDPOINT + "tickets/comment/" + ticket, {
        method: "POST",
        body: JSON.stringify(_json)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function changePriority(ticket, priority) {
    const _json = { "priority": priority};
    const res = await fetch(API_ENDPOINT + "tickets/priority/" + ticket, {
        method: "POST",
        body: JSON.stringify(_json)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function changeEscalation(ticket, escalation) {
    const _json = { "escalation": escalation};
    const res = await fetch(API_ENDPOINT + "tickets/escalation/" + ticket, {
        method: "POST",
        body: JSON.stringify(_json)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}



